import React from 'react';
import Aux from '../../../../../hoc/_Aux';
import appLogo from '../../../../../assets/images/vie-logo.png';
import { Icon } from '@iconify/react';

const navLogo = props => {
  let toggleClass = ['mobile-menu'];
  if (props.collapseMenu) {
    toggleClass = [...toggleClass, 'on'];
  }

  return (
    <Aux>
      <div className="navbar-brand header-logo">
        <a className="b-brand">
          <div>
            <img className="menu-logo" src={appLogo} alt="Generic placeholder" />
          </div>
        </a>
        <Icon className={toggleClass.join(' ') + ' pointer'} style={{"color": "#075978"}} id="mobile-collapse" onClick={props.onToggleNavigation} icon={'feather:x'}></Icon>
      </div>
    </Aux>
  );
};

export default navLogo;
